var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { "max-width": "100%", height: "800px", bus: _vm.busModal },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Continuar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      !_vm.loading
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("Title", { attrs: { title: "Resgate total" } }),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  " Os ativos abaixo não foram encontrados em sua carteira na instituição atualizada. Caso não tenha realizado o resgate dos ativos, apenas ignore. "
                )
              ]),
              _c("p", [
                _vm._v(
                  " Caso tenha realizado o resgate, por favor, inserir a data de realização do resgate total: "
                )
              ]),
              _vm.assets.length > 0
                ? _c("v-simple-table", {
                    key: "tabela-ativos-aceitar",
                    ref: "table-ativos-aceitar",
                    staticStyle: { width: "100%" },
                    attrs: { "fixed-header": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-left",
                                      staticStyle: { "max-width": "300px" }
                                    },
                                    [_vm._v("Ativo")]
                                  ),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v("Corretora")
                                  ]),
                                  _c("th", { attrs: { colspan: "3" } })
                                ])
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.assets, function(ativo, index) {
                                  return _c(
                                    "tr",
                                    { key: ativo.nome_ativo + index },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: { "max-width": "300px" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(ativo.nome_ativo || "—") +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getCorretoras(ativo.corretora)
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "text-left" },
                                        [
                                          _c(
                                            "v-form",
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: _vm.masks.data,
                                                    expression: "masks.data"
                                                  }
                                                ],
                                                key: ativo.nome_ativo + index,
                                                attrs: {
                                                  label: "Data do resgate*",
                                                  dense: "",
                                                  rules: [
                                                    _vm.rules.required,
                                                    _vm.rules.data
                                                  ]
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    return _vm.coletarDataCotizacao(
                                                      ativo
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataResgate[
                                                      ativo.nome_ativo
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dataResgate,
                                                      ativo.nome_ativo,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataResgate[ativo.nome_ativo]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        [
                                          ["FII", "Ações", "Ação"].includes(
                                            ativo.tipo || ativo.Tipo
                                          )
                                            ? _c(
                                                "v-form",
                                                [
                                                  _c("v-currency-field", {
                                                    attrs: {
                                                      prefix: "R$ ",
                                                      label: "Preço Unitário*",
                                                      rules: [
                                                        _vm.rules.required
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.preco_unitario[
                                                          ativo.nome_ativo
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.preco_unitario,
                                                          ativo.nome_ativo,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "preco_unitario[ativo.nome_ativo]"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          [
                                            "Renda Fixa",
                                            "Tesouro Direto"
                                          ].includes(ativo.tipo || ativo.Tipo)
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "BaseButton",
                                                                  _vm._g(
                                                                    {
                                                                      staticStyle: {
                                                                        margin:
                                                                          "auto"
                                                                      },
                                                                      attrs: {
                                                                        loading:
                                                                          _vm
                                                                            .loadingAssets[
                                                                            ativo
                                                                              .id
                                                                          ] ===
                                                                          "vencimento",
                                                                        primary:
                                                                          "",
                                                                        small:
                                                                          "",
                                                                        outline:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.sendResgateTotal(
                                                                            ativo,
                                                                            "vencimento"
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticStyle: {
                                                                          color:
                                                                            "inherit"
                                                                        },
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " mdi-calendar-alert "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " Ativo vencido "
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Se o ativo venceu, informe a data de vencimento. "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center"
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                staticClass: "mr-2",
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "BaseButton",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  loading:
                                                                    _vm
                                                                      .loadingAssets[
                                                                      ativo.id
                                                                    ] ===
                                                                    "salvar",
                                                                  primary: "",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.sendResgateTotal(
                                                                      ativo
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "inherit"
                                                                  },
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-download-outline "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Resgatar "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " Se você realizou o resgate do ativo, "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " informe a data que foi realizado. "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "BaseButton",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  loading:
                                                                    _vm
                                                                      .loadingAssets[
                                                                      ativo.id
                                                                    ] ===
                                                                    "remove",
                                                                  dark: "",
                                                                  small: "",
                                                                  outline: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.remover(
                                                                      ativo
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "inherit"
                                                                  },
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-close "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Ignorar "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " Caso não tenha realizado o resgate, "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " apenas ignore a sugestão. "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm.$isWhitelabel() ||
                                            _vm.$currentUser().IS_CLIENTE
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "BaseButton",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      loading:
                                                                        _vm
                                                                          .loadingAssets[
                                                                          ativo
                                                                            .id
                                                                        ] ===
                                                                        "vincular",
                                                                      primary:
                                                                        "",
                                                                      small: "",
                                                                      outline:
                                                                        ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.openVincular(
                                                                          ativo
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticStyle: {
                                                                        color:
                                                                          "inherit"
                                                                      },
                                                                      attrs: {
                                                                        small:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " mdi-link "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " Vincular "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " Vincular à outro ativo da carteira. "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2247009873
                    )
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.loading
        ? _c("v-row", { attrs: { justify: "center", align: "center" } }, [
            _c(
              "div",
              { staticClass: "text-center ma-12 w-100" },
              [
                _c("v-progress-circular", {
                  attrs: { size: 50, color: "primary", indeterminate: "" }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }